/**
 * Client-safe admin role checks for Clerk useUser() objects.
 * Clerk exposes role flags on publicMetadata (not Stack's clientMetadata).
 */
export function getClerkPublicRoleMetadata(user) {
  if (!user) return {};
  return user.publicMetadata || {};
}

export function isClerkAdminUser(user) {
  const meta = getClerkPublicRoleMetadata(user);
  return meta["super-admin"] === true || meta["admin"] === true;
}
